import Proxy from '../Proxy';

class StatsOrdersComplexByManagerProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('stats/complex-by-managers', parameters);
  }
}

export default StatsOrdersComplexByManagerProxy;
